import React from 'react'

import { Container, ContainerBgProps, Content, ContentProps } from './styles'

type Props = ContainerBgProps & ContentProps

function Border({
  almond,
  background,
  bg,
  bottomLeft,
  bottomRight,
  light,
  primary,
  secondary,
  tertiary,
  topLeft,
  topRight,
}: Props) {
  return (
    <Container bg={bg}>
      <Content
        almond={almond}
        background={background}
        bottomLeft={bottomLeft}
        bottomRight={bottomRight}
        light={light}
        primary={primary}
        secondary={secondary}
        tertiary={tertiary}
        topLeft={topLeft}
        topRight={topRight}
      />
    </Container>
  )
}

export default Border
